import type { ComponentType, SVGProps } from 'react';
import { IconGem, IconHexa, IconLegion, IconLink, IconSword } from '../components/icons';

export interface NavItem {
  /** Route path. */
  to: string;
  /** Full label (desktop nav). */
  label: string;
  /** Short label for the mobile bottom tab bar. */
  shortLabel: string;
  /** Decorative glyph. A plain dingbat character where one reads cleanly as UI chrome (◆ ✓ ♟ —
   *  none of these render as colour emoji), or a bespoke `components/icons` SVG where the natural
   *  glyph would otherwise be an emoji pictograph (docs/DESIGN.md's anti-generic ban list). */
  glyph: string | ComponentType<SVGProps<SVGSVGElement>>;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { to: '/', label: 'Dashboard', shortLabel: 'Today', glyph: '◆' },
  { to: '/checklist', label: 'Checklist', shortLabel: 'Tasks', glyph: '✓' },
  { to: '/bosses', label: 'Bosses', shortLabel: 'Bosses', glyph: IconSword },
  { to: '/pitched', label: 'Pitched', shortLabel: 'Pitched', glyph: IconGem },
  { to: '/characters', label: 'Characters', shortLabel: 'Chars', glyph: '♟' },
  { to: '/links', label: 'Link Skills', shortLabel: 'Links', glyph: IconLink },
  // REV8: 8th mobile tab bar entry — at 375px that's 375/8 ≈ 46.9px per flex-1 tab, still above
  // the 44px min-w-tap floor (see AppShell's mobileLinkClasses), so it still fits without a
  // scroll/overflow treatment; recorded in REV8's Deviations per REV6's precedent.
  { to: '/legion', label: 'Legion', shortLabel: 'Legion', glyph: IconLegion },
  // REV20: /settings left NAV_ITEMS for the UserMenu popover (components/UserMenu.tsx) — the
  // mobile tab bar was already at the 44px-floor capacity the REV8 comment above describes, so
  // Hexa took its slot rather than growing the bar to 9. Total entry count is unchanged (still 8);
  // the command palette still resolves "settings" to /settings via lib/commandPalette.ts's
  // explicit page-suggestion fallback (buildPageSuggestions otherwise only sources from this list).
  { to: '/hexa', label: 'Hexa', shortLabel: 'Hexa', glyph: IconHexa },
];
